import { AlarmClock, Tags } from 'lucide-react';
import { Breadcrumb } from '../../../../components/Breadcrumb';
import { SettingsMenu, type SettingsMenuEntry } from '../../../../components/settings/SettingsMenu';

/*
  What Building Management configures — one row per surface, each leading to its own page.

  The rows carry DIFFERENT keys: the catalog is its own module, and the aging page is this
  module's own read (editing it takes `configure-aging`, which the page's Edit carries). So the
  route and the sidebar entry are gated on ANY of the two.
*/
const ENTRIES: SettingsMenuEntry[] = [
  {
    key: 'categories',
    label: 'Categories',
    description: 'What a maintenance item is — Permits, Air-conditioning, Elevators — and each kind’s own warning window.',
    icon: Tags,
    to: '/general-services/building-management/settings/categories',
    permission: 'maintenance-categories.read',
  },
  {
    key: 'aging',
    label: 'Aging',
    description: 'When an item reads as Near Expiration, and how long after expiring it escalates.',
    icon: AlarmClock,
    to: '/general-services/building-management/settings/aging',
    permission: 'building-management.read',
  },
];

/**
 * Building Management → Settings: a **menu of what the module configures**, not the settings
 * themselves. Each row leads to a full page.
 */
export function BuildingManagementSettingsPage() {
  return (
    <div className="flex h-full min-h-0 min-w-0 flex-col bg-slate-50">
      <Breadcrumb segments={['General Services', 'Building Management', 'Settings']} />

      <div className="modern-scrollbar min-h-0 flex-1 overflow-auto p-4">
        <div className="mx-auto flex max-w-3xl flex-col gap-3">
          <p className="text-xs text-slate-500">
            The catalog items are filed under, and the thresholds every item is aged against.
            The items themselves are on the Maintenance page.
          </p>

          <SettingsMenu entries={ENTRIES} />
        </div>
      </div>
    </div>
  );
}
